import { useEffect, useRef } from 'react';

const useEffectSkipFirst = (
  effect: () => void | (() => void),
  deps: React.DependencyList
) => {
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    return effect();
  }, deps);
}; 

export default useEffectSkipFirst;import { useEffect, useRef } from 'react';

const useEffectSkipFirst = (
  effect: () => void | (() => void),
  deps: React.DependencyList
) => {
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    return effect();
  }, deps);
}; 

export default useEffectSkipFirst;